import React, { forwardRef, useImperativeHandle } from 'react';

import * as General from '../General/General';
import * as rsuite from 'rsuite';
import { trackPromise } from 'react-promise-tracker';


const Auto_Ref = forwardRef((props, ref) => {

    const [List, setList] = React.useState([]);
    const[Type, setType]=React.useState(0);
    const on_Select = (event) => {
        props.onSelect(event)
    }

    const on_Change = (event) => {
        props.onChange(event)
    }
    useImperativeHandle(ref, () => ({

        Bind(type, title, date) {
            console.dir(type)
            setType(type);
            if (type == 0)
                setList([]);
            else if (type == 1) // BuyFactor
                setList([]);
            else if (type == 2) // TransferBetweenStore
                setList([]);
            else if (type == 3) // ReturnFromSale
                trackPromise(
                    fetch(General.ApiRoute() + '/Product/SearchByGroup', {
                        method: 'Get',
                        headers: {
                            'ApiKey': General.APIKey(),
                            'Title': title
                        },
                        credentials: 'include'
                    })
                        .then(res => res.json())
                        .then(result => {
                            var tmp = []
                            for (var i = 0; i < result.length; i++) {
                                tmp.push({
                                    Row: i + 1,
                                    value: result[i].id + "|" + result[i].groupTitle + " - " + result[i].title + ' - ' + result[i].brandTitle + " (" + result[i].identityNo + ")",
                                    lable: result[i].groupTitle + " - " + result[i].title + ' - ' + result[i].brandTitle + " (" + result[i].identityNo + ")",


                                })
                            }
                            setList(tmp)
                        })
                )

        },
    }),
        [props.value])

    return (
        <rsuite.AutoComplete
            data={List.map((product) => ({
                label: `${product.lable}`,
                value: `${product.value}`,
            }))}
            value={props.value}
            label={props.lable}
            onChange={on_Change}
            onSelect={on_Select}
            placeholder='مبنا'
            disabled={Type==0 ? true : false}
        />)
});

export default Auto_Ref;